import { createFileRoute } from '@tanstack/react-router';

import { HiringOpeningsPage } from '@/features/hiring/openings-page';

export const Route = createFileRoute('/_app/projects/$projectId/hiring/openings/')({
  component: PageRoute,
});

function PageRoute() {
  const { projectId } = Route.useParams();
  return <HiringOpeningsPage projectId={projectId} />;
}
